exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppImage {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  vertical-align: middle;\n}", ""]);

// exports
